import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from './AppIcon';

const AdminNavigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { path: '/admin-orders-management', label: '주문 관리', icon: 'ShoppingCart' },
    { path: '/admin-before-after-management', label: '비포&애프터', icon: 'Image' },
    { path: '/admin-products-management', label: '상품 관리', icon: 'Package' },
    { path: '/admin-customer-management', label: '고객 관리', icon: 'Users' },
    { path: '/admin-terms-management', label: '약관 관리', icon: 'FileText' },
  ];

  const isActive = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <header className="sticky top-0 z-50 w-full bg-card shadow-card">
        <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <Link to="/admin-orders-management" className="flex items-center space-x-2">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent/10">
                <Icon name="Shield" size={24} color="var(--color-accent)" />
              </div>
              <span className="text-xl font-bold text-foreground">관리자</span>
            </Link>

            <div className="hidden md:flex md:items-center md:space-x-1">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  className={`flex items-center space-x-2 rounded-md px-4 py-2 text-sm font-medium transition-all duration-150 ease-out hover:bg-muted ${
                    isActive(item?.path)
                      ? 'bg-accent text-accent-foreground'
                      : 'text-foreground'
                  }`}
                >
                  <Icon name={item?.icon} size={18} />
                  <span>{item?.label}</span>
                </Link>
              ))}
            </div>

            <button
              onClick={toggleMobileMenu}
              className="inline-flex items-center justify-center rounded-md p-2 text-foreground hover:bg-muted md:hidden"
              aria-label="메뉴 열기"
            >
              <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
            </button>
          </div>
        </nav>

        {isMobileMenuOpen && (
          <div className="border-t border-border md:hidden">
            <div className="space-y-1 px-4 pb-3 pt-2">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`flex items-center space-x-3 rounded-md px-3 py-2 text-base font-medium transition-all duration-150 ease-out ${
                    isActive(item?.path)
                      ? 'bg-accent text-accent-foreground'
                      : 'text-foreground hover:bg-muted'
                  }`}
                >
                  <Icon name={item?.icon} size={20} />
                  <span>{item?.label}</span>
                </Link>
              ))}
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default AdminNavigation;